import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { FaSms, FaUserAltSlash } from "react-icons/fa";
import { MdClose, MdInsertDriveFile, MdNote, MdRefresh, MdVideocam } from "react-icons/md";

export const getIconClassNotification = notyType =>{
    switch(notyType){
        case 'Creation':
            return <MdVideocam className='colorVerde' />
        case 'Cancel':
            return <MdClose className='colorRojo' />
        case 'Update':
            return <MdRefresh className='colorAzul'/>
        case 'Document':
            return <MdInsertDriveFile className='colorNaranja' />
        case 'Prescription':
            return <MdNote className='colorBlack' />
        case 'SMS':
            return <FaSms className='colorGray' />
        case 'DoctorNotConnected':
            return <FaUserAltSlash className='colorRojo' />
        case "Reassigned":
            return <AiOutlineUsergroupAdd className='colorAzul' />
        default: 
            return '';
    }
}